<template>
    <div>
        <Fieldset :legend="$t('searchHeader')" :toggleable="true">
            <div class="p-fluid p-mt-2 p-ml-4 p-mr-4 p-mb-2">
                <div class="p-formgrid p-grid p-col-12 p-ml-2">
                    <div class="p-col-12 p-lg-6">
                        <div class="p-formgrid p-grid">
                            <div class="p-field p-col-10 p-lg-10">
                                <label class="p-mr-2">{{ $t('organize_response') }}</label>
                                <Button @click="showOrganize = true" icon="pi pi-plus" class="p-button-success" />
                            </div>
                        </div>
                        <div class="p-field p-col p-mt-2" style="margin-left: -10px">
                            <DataTable
                                :value="organize_table"
                                :scrollable="true"
                                scrollHeight="500px"
                                :paginator="true"
                                :rows="5"
                                dataKey="id"
                                ref="dt"
                                :rowHover="true"
                                :selection.sync="selectedOrganizeData"
                                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                                :rowsPerPageOptions="[5, 10, 20, 50]"
                                currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
                            >
                                <template #empty>{{ $t('TableEmpty') }}</template>
                                <Column field="organize_name" :header="$t('id_operating_name')" :sortable="true" headerStyle="width: 15rem">
                                    <template #body="dataTable">
                                        <div hidden>{{ dataTable.data.organize_id }}</div>
                                        {{ dataTable.data.organize_name }}
                                    </template>
                                </Column>
                                <Column :header="$t('controlTable')" headerStyle="width: 15rem">
                                    <template #body="dataTable">
                                        <div class="p-formgrid p-grid">
                                            <div class="p-field p-col-6">
                                                <Button
                                                    @click="
                                                        // displayConfirmation = true;
                                                        organizeDelete = dataTable.data;
                                                        alertDisplay(organizeDelete);
                                                    "
                                                    icon="pi pi-trash"
                                                    :label="$t('deleteBtn')"
                                                    class="p-button-rounded p-button-danger"
                                                />
                                            </div>
                                        </div>
                                    </template>
                                </Column>
                            </DataTable>
                        </div>
                    </div>

                    <div class="p-col-12 p-lg-6 p-mt-2">
                        <div class="p-formgrid p-grid">
                            <div class="p-field p-col-11 p-lg-11">
                                <label>{{ $t('label_type_device') }}</label>
                                <MultiSelect
                                    v-model="deviceTypeSelected"
                                    :options="deviceTypeOptions"
                                    optionLabel="system_name"
                                    :placeholder="$t('placeholderSelectBox')"
                                    :filter="true"
                                    class="multiselect-custom"
                                    :clearFilterMultiSelect="multiSelectClearFilerValue"
                                >
                                    <template #value="slotProps">
                                        <div class="item item-value" v-for="option of slotProps.value" :key="option.id">
                                            <div>{{ option.system_name }}</div>
                                        </div>
                                        <template v-if="!slotProps.value || slotProps.value.length === 0">
                                            {{ $t('placeholderSelectBox') }}
                                        </template>
                                    </template>
                                    <template #option="slotProps">
                                        <div class="item">
                                            <div>{{ slotProps.option.system_name }}</div>
                                        </div>
                                    </template>
                                </MultiSelect>
                            </div>
                            <div class="p-field p-col-1 p-lg-1 p-mt-5">
                                <Button
                                    @click="
                                        deviceTypeSelected = null;
                                        multiSelectClearFilerValue += 1;
                                    "
                                    icon="pi pi-times"
                                    class="p-button-danger p-mt-2"
                                />
                            </div>
                        </div>
                        <!-- <span class="p-invalid" v-if="error_device == true">{{$t('table_validate')}}</span> -->

                        <!-- + เงื่อนไข -->
                        <div v-if="deviceTypeSelected != null">
                            <div v-if="deviceTypeSelected.length == '2'">
                                <!-- 1 ถ้าเลือกแล้วมียานพาหนะ -->
                                <div v-if="deviceTypeSelected[0].system_id == 'gs-00000002' || deviceTypeSelected[1].system_id == 'gs-00000002'">
                                    <div class="p-formgrid p-grid p-mt-2">
                                        <div class="p-field p-col-11 p-lg-11 p-mt-2">
                                            <label>{{ $t('label_type_vehicle') }}</label>
                                            <MultiSelect
                                                v-model="vehicleSelected"
                                                :options="vehicleOptions"
                                                optionLabel="system_name"
                                                :placeholder="$t('placeholderSelectBox')"
                                                :filter="true"
                                                class="multiselect-custom"
                                                :clearFilterMultiSelect="multiSelectClearFilerValue"
                                            >
                                                <template #value="slotProps">
                                                    <div class="item item-value" v-for="option of slotProps.value" :key="option.id">
                                                        <div>{{ option.system_name }}</div>
                                                    </div>
                                                    <template v-if="!slotProps.value || slotProps.value.length === 0">
                                                        {{ $t('placeholderSelectBox') }}
                                                    </template>
                                                </template>
                                                <template #option="slotProps">
                                                    <div class="item">
                                                        <div>{{ slotProps.option.system_name }}</div>
                                                    </div>
                                                </template>
                                            </MultiSelect>
                                        </div>
                                        <div class="p-field p-col-1 p-lg-1 p-mt-5">
                                            <Button
                                                @click="
                                                    vehicleSelected = null;
                                                    multiSelectClearFilerValue += 1;
                                                "
                                                icon="pi pi-times"
                                                class="p-button-danger p-mt-2"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <!--end 1 ถ้าเลือกแล้วมียานพาหนะ -->
                            </div>

                            
                            <div v-if="deviceTypeSelected.length == '1'">
                                <!-- 2 ถ้าเลือกแค่ยานพาหนะ -->
                                <div v-if="deviceTypeSelected[0].system_id == 'gs-00000002'">
                                    <div class="p-formgrid p-grid p-mt-2">
                                        <div class="p-field p-col-11">
                                            <label>{{ $t('label_type_vehicle') }}</label>
                                            <MultiSelect
                                                v-model="vehicleSelected"
                                                :options="vehicleOptions"
                                                optionLabel="system_name"
                                                :placeholder="$t('placeholderSelectBox')"
                                                :filter="true"
                                                class="multiselect-custom"
                                                :clearFilterMultiSelect="multiSelectClearFilerValue"
                                            >
                                                <template #value="slotProps">
                                                    <div class="item item-value" v-for="option of slotProps.value" :key="option.id">
                                                        <div>{{ option.system_name }}</div>
                                                    </div>
                                                    <template v-if="!slotProps.value || slotProps.value.length === 0">
                                                        {{ $t('placeholderSelectBox') }}
                                                    </template>
                                                </template>
                                                <template #option="slotProps">
                                                    <div class="item">
                                                        <div>{{ slotProps.option.system_name }}</div>
                                                    </div>
                                                </template>
                                            </MultiSelect>
                                        </div>
                                        <div class="p-field p-col-1 p-mt-5">
                                            <Button
                                                @click="
                                                    vehicleSelected = null;
                                                    multiSelectClearFilerValue += 1;
                                                "
                                                icon="pi pi-times"
                                                class="p-button-danger p-mt-2"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div v-else>
                                    {{ (vehicleSelected = null) }}
                                </div>

                                <!--end 2 ถ้าเลือกแค่ยานพาหนะ -->
                            </div>
                        </div>
                        <!-- /+ -->

                        <!-- <span class="p-invalid" v-if="error_vehicle == true">{{$t('table_validate')}}</span> -->

                        <div class="p-formgrid p-grid p-mt-4 p-jc-end">
                            <div class="p-field p-col p-mt-2">
                                <!-- <Button
                    @click="exportCSV()"
                    :label="$t('exportBtn')"
                    class="p-button-info p-mr-3"
                    style="background-color: green"
                  /> -->
                                <Button @click="clearSearchField()" :label="$t('clearBtn')" class="p-button-clear p-mr-3" />
                                <Button
                                    @click="
                                        search();
                                        cou = true;
                                    "
                                    :label="$t('searchBtn')"
                                    class="p-button-info p-mr-2"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="p-formgrid p-grid p-col p-mt-1">
                    <text-footer :data="Data_text_Footer" :checkShow="text_Footer" :countItem="table.length.toLocaleString('en-US')" />
                </div>
            </div>
        </Fieldset>

        <!-- :contentStyle="{'overflow-y': 'scroll'}" -->
        <Dialog :modal="true" :header="$t('OrganizeModalHeader')" :visible.sync="showOrganize" :style="{ width: '80%' }">
            <organize-table @selectOrganization="selectedOrganize_passValue" :parentmessage="parentmessage_organize"></organize-table>
        </Dialog>

        <div class="card p-fluid p-mt-2">
            <!-- Doe : เพิ่ม ลำดับ 1/4   sortField="index" :sortOrder="1" -->
            <DataTable
                :value="table"
                :scrollable="true"
                scrollHeight="500px"
                :paginator="true"
                :rows="10"
                dataKey="id"
                ref="dt"
                :exportFilename="`รายละเอียดข้อมูลเครื่องมือฯ-${date}`"
                :rowHover="true"
                :filters="filters"
                :sortOrder="1"
                sortField="index"
                :loading="loading"
                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                :rowsPerPageOptions="[10, 20, 50]"
                currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
            >
                <!-- Doe : เพิ่ม ลำดับ 1/4 จบ  sortField="index" :sortOrder="1" -->
                <template #header>
                    <div class="p-grid p-col">
                        <!-- Doe : PDF 1/3 -->
                        <div class="table-header" style="padding: 7px">
                            <Button @click="exportCSV()" :label="$t('exportBtn')" class="p-button-info" style="background-color: green" />
                        </div>
                        <div class="table-header" style="padding: 7px">
                            <SplitButton
                                label="ส่งออก PDF"
                                :model="items"
                                class="p-button-raised p-button-danger"
                                style="background-color: #f33737"
                            ></SplitButton>
                        </div>
                        <!-- Doe : PDF 1/3 จบ -->

                        <!-- Doe PDF เลือกได้  1/5   -->
                        <div class="table-header" id="TABLE_EDIT" style="padding: 7px">
                            <Button
                                @click="EditPDF()"
                                icon="pi pi-cog"
                                :label="'ตั้งค่า'"
                                style="background-color: #0288d1; border: 1px solid #0288d1"
                            />
                        </div>
                        <!-- Doe PDF เลือกได้  1/5 จบ  -->

                        <div class="table-header p-col-12 p-lg-3" id="Search" style="margin-left: auto">
                            <!-- <span class="p-input-icon-left">
                <i class="pi pi-search" /><InputText
                  v-model="filters['global']"
                  :placeholder="$t('searchHeader')"
                />
              </span> -->

                            <!-- Doe ค้นหา  1/5 -->
                            <span class="p-input-icon-left" v-if="columns_disabled && cou">
                                <i class="pi pi-search" />
                                <InputText v-model="filter" @input="searchTable()" :placeholder="$t('searchHeader')" />
                            </span>
                            <span class="p-input-icon-left" v-else>
                                <i class="pi pi-search" />
                                <InputText disabled v-model="filter" @input="searchTable()" :placeholder="$t('searchHeader')" />
                            </span>
                            <!-- Doe ค้นหา  1/5 จบ-->
                        </div>
                    </div>
                </template>
                <!-- <template #header>
          <div class="table-header p-col-6 p-lg-3" style="margin-left: auto">
            <span class="p-input-icon-left">
              <i class="pi pi-search" /><InputText
                v-model="filters['global']"
                :placeholder="$t('searchHeader')"
              />
            </span>
          </div>
        </template> -->
                <template #empty>{{ $t('TableEmpty') }}</template>
                <!--Doe : เพิ่มลำดับ 2/4-->
                <div v-if="columns_index == true">
                    <Column field="index" :header="'ลำดับ'" :sortable="true" :headerStyle="{ width: '8rem', textAlign: 'center' }">
                        <template #body="dataTable">
                            <div class="table_row">
                                {{ dataTable.data.index }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column headerStyle="width: 0"></Column>
                </div>
                <!--Doe : เพิ่มลำดับ 2/4 จบ-->

                <div v-if="columns_ev_name == true">
                    <Column field="ev_name" :header="$t('name')" :sortable="true" headerStyle="width: 15rem">
                        <template #body="dataTable">
                            {{ dataTable.data.ev_name }}
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column headerStyle="width: 0"></Column>
                </div>

                <!-- เพิ่ม coloums ชื่อเครื่องมือฯ (ชื่อมาตรฐาน) -->
                <div v-if="columns_ev_standard_name == true">
                    <Column field="ev_standard_name" :header="$t('iev_equipment_standard_name')" :sortable="true" headerStyle="width: 250px">
                        <template #body="dataTable">
                            <div hidden>{{ dataTable.data.ev_id }}</div>
                            {{
                                dataTable.data.ev_standard_name == 'null' ||
                                dataTable.data.ev_standard_name == null ||
                                dataTable.data.ev_standard_name == ''
                                    ? '-'
                                    : dataTable.data.ev_standard_name
                            }}
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column headerStyle="width: 0"></Column>
                </div>
                <!-- เพิ่ม coloums ชื่อเครื่องมือฯ (ชื่อมาตรฐาน) จบ -->

                <div v-if="columns_group == true">
                    <Column field="group" :header="$t('group')" :sortable="true" :headerStyle="{ width: '15rem', textAlign: 'center' }">
                        <template #body="dataTable">
                            <div class="table_row">
                                {{ dataTable.data.group }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column headerStyle="width: 0"></Column>
                </div>

                <div v-if="columns_system_name == true">
                    <Column field="system_name" :header="$t('type')" :sortable="true" :headerStyle="{ width: '15rem', textAlign: 'center' }">
                        <template #body="dataTable">
                            <div class="table_row">
                                {{ dataTable.data.system_name }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column headerStyle="width: 0"></Column>
                </div>

                <!--เพิ่ม columns แบรนด์รถ-->

                <Column field="ev_car_brand" :header="$t('ยี่ห้อ')" :sortable="true" :headerStyle="{ width: '15rem', textAlign: 'center' }">
                    <template #body="dataTable">
                        <div class="table_row">
                            <div v-if="dataTable.data.ev_car_brand == ''">-</div>
                            <div v-else>{{ dataTable.data.ev_car_brand }}</div>
                        </div>
                    </template>
                </Column>

                <!-- เพิ่ม coloums หมายเลขครุภัณฑ์ -->
                <div v-if="columns_ev_number == true">
                    <Column field="ev_number" :header="$t('iev_equipment_number')" :sortable="true" headerStyle="width: 240px">
                        <template #body="dataTable">
                            <div hidden>{{ dataTable.data.ev_id }}</div>
                            {{
                                dataTable.data.ev_number == 'null' || dataTable.data.ev_number == null || dataTable.data.ev_number == ''
                                    ? '-'
                                    : dataTable.data.ev_number
                            }}
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column headerStyle="width: 0"></Column>
                </div>
                <!-- เพิ่ม coloums หมายเลขครุภัณฑ์ จบ -->

                <!-- ! เลขทะเบียน -->
                <div v-if="columns_ev_license_plate == true">
                    <Column field="ev_license_plate" :header="$t('ct_ev_license_plate')" :sortable="true" headerStyle="width: 15rem">
                        <template #body="dataTable">
                            <div v-if="dataTable.data.ev_license_plate == ''">-</div>
                            <div v-else>{{ dataTable.data.ev_license_plate }}</div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column headerStyle="width: 0"></Column>
                </div>
                <!-- ! end เลขทะเบียน -->

                <!-- !หมายเลขข้างรถ-->
                <div v-if="columns_ev_sidecar_number == true">
                    <Column field="ev_sidecar_number" :header="$t('ev_sidecar_number')" :sortable="true" headerStyle="width: 15rem">
                        <template #body="dataTable">
                            <div v-if="dataTable.data.ev_sidecar_number == ''">-</div>
                            <div v-else>{{ dataTable.data.ev_sidecar_number }}</div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column headerStyle="width: 0"></Column>
                </div>
                <!-- ! end หมายเลขข้างรถ -->

                <div v-if="columns_organize_name == true">
                    <Column field="organize_name" :header="$t('organize_response')" :sortable="true" headerStyle="width: 15rem">
                        <template #body="dataTable">
                            {{ dataTable.data.organize_name }}
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column headerStyle="width: 0"></Column>
                </div>

                <div v-if="columns_status == true">
                    <!-- ! สถานะ-->
                    <Column field="status" :header="$t('ev_status')" :sortable="true" :headerStyle="{ width: '15rem', textAlign: 'center' }">
                        <template #body="dataTable">
                            <!-- <div class="table_row">
                {{ dataTable.data.status }}
              </div> -->
                            <div v-if="dataTable.data.status == 'พร้อมใช้'" class="table_row">
                                <div class="table_statusColor" style="background-color: #58d68d">
                                    {{ dataTable.data.status }}
                                </div>
                            </div>
                            <div v-else-if="dataTable.data.status == 'ซ่อม'" class="table_row">
                                <div class="table_statusColor" style="background-color: #dd0000">
                                    {{ dataTable.data.status }}
                                </div>
                            </div>
                            <div v-else-if="dataTable.data.status == 'ชำรุด'" class="table_row">
                                <div class="table_statusColor" style="background-color: #e74c3c">
                                    {{ dataTable.data.status }}
                                </div>
                            </div>
                            <div v-else-if="dataTable.data.status == 'รอจำหน่าย'" class="table_row">
                                <div class="table_statusColor" style="background-color: #f1948a">
                                    {{ dataTable.data.status }}
                                </div>
                            </div>
                            <div v-else class="table_row">
                                <div class="table_statusColor" style="background-color: #fadbd8">
                                    {{ dataTable.data.status }}
                                </div>
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column headerStyle="width: 0"></Column>
                </div>

                <div v-if="columns_ev_detail == true">
                    <Column field="ev_detail" :header="$t('imp_detail')" :sortable="true" headerStyle="width: 200px">
                        <template #body="dataTable">
                            {{ dataTable.data.ev_detail }}
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column headerStyle="width: 0"></Column>
                </div>

                <!-- <Column field="ev_status" :header="$t('ev_status')" :sortable="true">
          <template #body="dataTable">
           <div v-if="dataTable.data.ev_status == '1'">
              {{ $t("status_ready") }}
            </div>
            <div v-else-if="dataTable.data.ev_status == '2'">
              {{ $t("status_fix") }}
            </div>
            <div v-else-if="dataTable.data.ev_status == '3'">
              {{ $t("status_bad") }}
            </div>
              <div v-else-if="dataTable.data.ev_status == '4'">
              {{ $t("status_waitSale") }}
            </div>
              <div v-else-if="dataTable.data.ev_status == '5'">
              {{ $t("status_sale") }}
            </div>
            <div v-else>{{ $t("status_bad") }}</div>
          </template>
        </Column> -->

                <!-- ! end สถานะ -->
                <!-- เพิ่ม coloums จำนวน -->
                <!-- อันเก่าของโด้ -->
                <!-- <Column
          field="item"
          :header="$t('iev_count')"
          :sortable="true"
          headerStyle="width: 250px"
        >
          <template #body="dataTable">
            {{ dataTable.data.item  == 'null' ||
            dataTable.data.item  == null || 
            dataTable.data.item  == '' ? '-' : dataTable.data.item}}
          </template>
        </Column> -->
                <!-- อันใหม่ของป๊อปอาย -->
                <div v-if="columns_ev_amount == true">
                    <Column
                        field="ev_amount"
                        :header="$t('iev_equipment_amount')"
                        :sortable="true"
                        :headerStyle="{ width: '15rem', textAlign: 'center' }"
                    >
                        <template #body="dataTable">
                            <div hidden>{{ dataTable.data.ev_id }}</div>
                            <div class="table_row">
                                {{
                                    dataTable.data.ev_amount == 'null' || dataTable.data.ev_amount == null || dataTable.data.ev_amount == ''
                                        ? '-'
                                        : dataTable.data.ev_amount
                                }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column headerStyle="width: 0"></Column>
                </div>
                <!-- เพิ่ม coloums จำนวน จบ -->

                <div v-if="columns_ev_response_name == true">
                    <Column field="ev_response_name" :header="$t('ct_name') + ' (สังกัด)'" :sortable="true" headerStyle="width: 25rem">
                        <template #body="dataTable">
                            <div v-if="dataTable.data.ev_response_name == ''">-</div>
                            <div v-else>{{ dataTable.data.ev_response_name }}</div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column headerStyle="width: 0"></Column>
                </div>

                <div v-if="columns_ev_response_phone == true">
                    <!-- <Column
            field="ev_response_phone"
            :header="$t('ct_phone')"
            :sortable="true"
            headerStyle="width: 15rem"
          >
            <template #body="dataTable">
              <div v-if="dataTable.data.ev_response_phone == ''">-</div>
              <div v-else>{{ dataTable.data.ev_response_phone }}</div>
              
            </template>
          </Column> -->
                    <Column field="text_tel_detail" :header="$t('ct_phone')" :sortable="true" headerStyle="width: 250px">
                        <template #body="dataTable">
                            <span v-html="dataTable.data.text_tel_detailHTML"></span>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column headerStyle="width: 0"></Column>
                </div>

                <div v-if="columns_ev_date == true">
                    <Column
                        field="ev_date"
                        :header="$t('imp_update_info_date')"
                        :sortable="true"
                        :headerStyle="{ width: '250px', textAlign: 'center' }"
                    >
                        <template #body="dataTable">
                            <div class="table_row">
                                {{ dataTable.data.ev_date }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column headerStyle="width: 0"></Column>
                </div>

                <div v-if="columns_user_fullname == true">
                    <Column field="user_fullname" :header="$t('imp_editor')" :sortable="true" headerStyle="width: 200px">
                        <template #body="dataTable">
                            {{ dataTable.data.user_fullname }}
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column headerStyle="width: 0"></Column>
                </div>
            </DataTable>
        </div>

        <Dialog :modal="true" :header="$t('ConfirmDelete')" :visible.sync="displayConfirmation" :style="{ width: '350px' }">
            <div class="confirmation-content p-mt-3">
                <i class="pi pi-exclamation-triangle p-mr-3 p-mt2" style="font-size: 2rem" />
                <span>{{ $t('ConfirmDeleteSub') }}</span>
            </div>
            <template #footer>
                <Button :label="$t('cancelBtn')" icon="pi pi-times" @click="displayConfirmation = false" class="p-button-text" />
                <Button :label="$t('confirmBtn')" icon="pi pi-check" @click="confirmDelete()" class="p-button-text" autofocus />
            </template>
        </Dialog>

        <!-- Doe PDF เลือกได้  -->
        <Dialog header="ตั้งค่า " :visible.sync="displayEditPDF" :style="{ width: '25rem' }" :contentStyle="{ 'overflow-y': 'visible' }">
            <label>ตั้งค่าการแสดงข้อมูลตารางและการส่งออกข้อมูล</label>
            <div style="margin: 2.5rem 1rem 0 1rem">
                <div class="p-formgrid p-grid">
                    <div class="p-field p-col-12">
                        <MultiSelect
                            v-model="columnsSelectorDialog"
                            :options="columns"
                            optionLabel="title"
                            :placeholder="$t('placeholderSelectBox')"
                            :filter="true"
                            class="multiselect-custom"
                            :clearFilterMultiSelect="multiSelectClearFilerValue"
                        >
                            <template #value="slotProps">
                                <div class="item item-value" v-for="option of slotProps.value" :key="option.dataKey">
                                    <div>{{ option.title }}</div>
                                </div>
                                <template v-if="!slotProps.value || slotProps.value.length === 0">
                                    {{ $t('placeholderSelectBox') }}
                                </template>
                            </template>
                            <template #option="slotProps">
                                <div class="item">
                                    <div>{{ slotProps.option.title }}</div>
                                </div>
                            </template>
                        </MultiSelect>
                        <div style="margin-top: 1rem; display: flex; justify-content: flex-end">
                            <Button
                                @click="
                                    ClearEditPDF();
                                    multiSelectClearFilerValue += 1;
                                "
                                class="p-button-clear"
                                :label="'ล้างข้อมูล'"
                                style="margin-right: 1rem"
                            />
                            <Button @click="SelectAllEditPDF()" class="p-button-info" :label="'เลือกทั้งหมด'" />
                        </div>
                    </div>
                </div>
            </div>
            <template #footer>
                <div>
                    <Button @click="CloseEditPDF()" :label="'ยกเลิก'" icon="pi pi-times" class="p-button-text" />
                    <Button @click="SaveEditPDF()" :label="'บันทึก'" icon="pi pi-check" class="p-button-text" />
                </div>
            </template>
        </Dialog>
        <!-- Doe PDF เลือกได้ -->
    </div>
</template>

<script>
import organizeTable from '../OrganizeMultiSelectTable';
// Doe : PDF 2/3
// เพิ่ม pdf กับ font
// import { jsPDF } from "jspdf";
// import {font} from '../../../../public/assets/font/Sarabun-Regular-normal';
// Doe : PDF 2/3 จบ

import moment from 'moment';
import textFooter from '../../../mixins/textFooter_Search_html';

export default {
    name: 'report-equipment-detail',
    components: {
        organizeTable,
        textFooter
    },
    data() {
        return {
            columns_ev_car_brand: true,
            multiSelectClearFilerValue: 0,
            date: moment().locale('th').add(543, 'year').format('l'),
            // Doe ค้นหา  2/5
            filter: '',
            cou: false,
            cloneTable: [],
            // Doe ค้นหา  2/5 จบ

            table: [],
            filters: {},
            displayConfirmation: false,
            showOrganize: false,

            deviceTypeOptions: [],
            deviceTypeSelected: null,

            vehicleOptions: [],
            vehicleSelected: null,

            selectedOrganizeData: null,
            organize_table: [],

            organizeDelete: null,

            error_device: false,
            error_vehicle: false,

            loading: false,

            parentmessage_organize: null,

            //
            text_Footer: false,
            Clone_Data_text_Footer: [],
            Data_text_Footer: [
                {
                    DataName: 'หน่วยงานรับผิดชอบ',
                    textShow: ''
                },
                {
                    DataName: 'ประเภทเครื่องมือ/อุปกรณ์',
                    textShow: ''
                },
                {
                    DataName: 'ประเภทยานพาหนะ',
                    textShow: ''
                }
            ],

            // Doe PDF เลือกได้  2/5
            setPDF_Hor: 'l',
            setPosition_Hor: [802, 34, 802, 570],
            setPDF_Ver: 'p',
            setPosition_Ver: [570, 34, 575, 815],
            setPDF_Styles: 'grid',
            setnamePDF: 'ตารางข้อมูลเครื่องมืออุปกรณ์/ยานพาหนะ',
            setPDF_fillColor: [95, 154, 250],
            setPDF_Margin: { left: 15, right: 15 },

            PDF_minCellWidthVer: 40,
            PDF_FontHeaderVer: 7.5,
            PDF_FontBodyVer: 5.5,

            PDF_BodySizeSelect: {},
            PDF_BodySize: {
                index: { cellWidth: 21.5 },
                ev_name: { cellWidth: 28 },
                ev_standard_name: { cellWidth: 40 },
                group: { cellWidth: 42, fontSize: 6 },
                system_name: { cellWidth: 38, fontSize: 6 },
                ev_number: { cellWidth: 35 },
                ev_license_plate: { cellWidth: 35 },
                ev_sidecar_number: { cellWidth: 38 },
                organize_name: { cellWidth: 45 },

                text_tel_detail: { cellWidth: 28 },
                // ev_response_phone:{cellWidth:28},

                ev_detail: { cellWidth: 33 },
                ev_response_name: { cellWidth: 42 },

                status: { cellWidth: 27 },
                ev_amount: { cellWidth: 24.5 },
                // user_fullname:{cellWidth:48.5},
                ev_date: { cellWidth: 37 }
            },

            PDF_minCellWidthHor: 50,
            PDF_FontHeaderHor: 12,
            PDF_FontBodyHor: 10,

            PDF_BodySizeHorSelect: {},
            PDF_BodySizeHor: {
                index: { cellWidth: 30 },
                ev_name: { cellWidth: 55 },
                ev_standard_name: { cellWidth: 70 },
                group: { cellWidth: 60, fontSize: 10 },
                system_name: { cellWidth: 60, fontSize: 10 },
                ev_number: { cellWidth: 50 },
                ev_license_plate: { cellWidth: 50 },
                ev_sidecar_number: { cellWidth: 45 },
                organize_name: { cellWidth: 70 },

                text_tel_detail: { cellWidth: 40 },
                // ev_response_phone:{cellWidth:40},

                ev_detail: { cellWidth: 49 },
                ev_response_name: { cellWidth: 50 },

                status: { cellWidth: 40 },
                ev_amount: { cellWidth: 35 },
                ev_date: { cellWidth: 55, fontSize: 10 }
            },
            columns: [
                { title: 'ลำดับ', dataKey: 'index' },
                { title: 'ชื่อเครื่องมือฯ', dataKey: 'ev_name' },
                { title: 'ชื่อเครื่องมือฯ(ชื่อมาตรฐาน)', dataKey: 'ev_standard_name' },
                { title: 'กลุ่มเครื่องมือฯ', dataKey: 'group' },
                { title: 'ประเภทเครื่องมือฯ', dataKey: 'system_name' },
                { title: 'หมายเลขครุภัณฑ์', dataKey: 'ev_number' },
                { title: 'เลขทะเบียน', dataKey: 'ev_license_plate' },
                { title: 'หมายเลขข้างรถ', dataKey: 'ev_sidecar_number' },
                { title: 'หน่วยงานที่รับผิดชอบ', dataKey: 'organize_name' },
                { title: 'สถานะ', dataKey: 'status' },
                { title: 'รายละเอียดเพิ่มเติม', dataKey: 'ev_detail' },
                { title: 'จำนวน', dataKey: 'ev_amount' },
                { title: 'ผู้รับผิดชอบ(สังกัด)', dataKey: 'ev_response_name' },
                // {title: "เบอร์โทร", dataKey: "ev_response_phone"},
                { title: 'เบอร์โทร', dataKey: 'text_tel_detail' },
                { title: 'วันที่ปรับปรุงล่าสุด', dataKey: 'ev_date' },
                { title: 'ผู้แก้ไข', dataKey: 'user_fullname' },
                {title: 'ยี่ห้อ', dataKey: 'ev_car_brand'}
            ],

            columnsSelector: null,
            columnsSelectorDialog: null,

            displayEditPDF: false,

            columns_index: true,
            columns_ev_name: true,
            columns_ev_standard_name: true,
            columns_group: true,
            columns_system_name: true,
            columns_ev_number: true,
            columns_ev_license_plate: true,
            columns_ev_sidecar_number: true,

            columns_organize_name: true,
            columns_status: true,
            columns_ev_detail: true,
            columns_ev_amount: true,
            columns_ev_response_name: true,
            columns_ev_response_phone: true,
            columns_ev_date: true,
            columns_user_fullname: true,

            columns_disabled: true,
            GetData_ColumnsSearch: [],
            // Doe PDF เลือกได้  2/5  จบ

            // Doe : PDF 3/3
            items: [
                {
                    label: ' แนวตั้ง',
                    command: () => {
                        if (this.table == '') {
                            this.$toast.add({ severity: 'warn', summary: 'PDF', detail: 'ไม่มีข้อมูล', life: 3000 });
                        } else {
                            this.$toast.add({ severity: 'success', summary: 'PDF', detail: 'แนวตั้ง', life: 3000 });

                            let columns = this.columnsSelector;

                            const Body_setCenter = ['index', 'ev_amount', 'group', 'system_name', 'status', 'ev_date'];

                            const fill_row_detail = [
                                {
                                    name_row: 'status',
                                    detail_row: [
                                        {
                                            check_text: 'พร้อมใช้',
                                            fill_color: [88, 214, 141]
                                        },
                                        {
                                            check_text: 'ซ่อม',
                                            fill_color: [221, 0, 0]
                                        },
                                        {
                                            check_text: 'ชำรุด',
                                            fill_color: [231, 76, 60]
                                        },
                                        {
                                            check_text: 'รอจำหน่าย',
                                            fill_color: [241, 148, 138]
                                        },
                                        {
                                            check_text: 'จำหน่าย',
                                            fill_color: [250, 219, 216]
                                        }
                                    ]
                                }
                            ];

                            const PintPDF = {
                                streak: this.setPDF_Ver,
                                setPosition: this.setPosition_Ver,
                                PDF_Styles: this.setPDF_Styles,
                                data: this.$refs.dt.processedData,
                                columns: columns,
                                columnsStyles: this.PDF_BodySizeSelect,
                                FileName: this.setnamePDF,
                                checkBody_Center: true,
                                Body_Center: Body_setCenter,
                                Col_FontSize: this.PDF_FontHeaderVer,
                                Body_FontSize: this.PDF_FontBodyVer,
                                minCell: this.PDF_minCellWidthVer,
                                marginPDF: this.setPDF_Margin,
                                fillColorPDF: this.setPDF_fillColor,
                                //
                                check_fill_row: true,
                                fill_row_detail: fill_row_detail
                            };
                            this.printPDF(PintPDF);
                        }
                    }
                },

                {
                    label: 'แนวนอน',
                    command: () => {
                        if (this.table == '') {
                            this.$toast.add({ severity: 'warn', summary: 'PDF', detail: 'ไม่มีข้อมูล', life: 3000 });
                        } else {
                            this.$toast.add({ severity: 'success', summary: 'PDF', detail: 'แนวนอน', life: 3000 });
                            let columns = this.columnsSelector;

                            const Body_setCenter = ['index', 'ev_amount', 'group', 'system_name', 'status', 'ev_date'];

                            const fill_row_detail = [
                                {
                                    name_row: 'status',
                                    detail_row: [
                                        {
                                            check_text: 'พร้อมใช้',
                                            fill_color: [88, 214, 141]
                                        },
                                        {
                                            check_text: 'ซ่อม',
                                            fill_color: [221, 0, 0]
                                        },
                                        {
                                            check_text: 'ชำรุด',
                                            fill_color: [231, 76, 60]
                                        },
                                        {
                                            check_text: 'รอจำหน่าย',
                                            fill_color: [241, 148, 138]
                                        },
                                        {
                                            check_text: 'จำหน่าย',
                                            fill_color: [250, 219, 216]
                                        }
                                    ]
                                }
                            ];

                            const PintPDF = {
                                streak: this.setPDF_Hor,
                                setPosition: this.setPosition_Hor,
                                PDF_Styles: this.setPDF_Styles,
                                data: this.$refs.dt.processedData,
                                columns: columns,
                                columnsStyles: this.PDF_BodySizeHorSelect,
                                FileName: this.setnamePDF,
                                checkBody_Center: true,
                                Body_Center: Body_setCenter,
                                Col_FontSize: this.PDF_FontHeaderHor,
                                Body_FontSize: this.PDF_FontBodyHor,
                                minCell: this.PDF_minCellWidthHor,
                                marginPDF: this.setPDF_Margin,
                                fillColorPDF: this.setPDF_fillColor,
                                //
                                check_fill_row: true,
                                fill_row_detail: fill_row_detail
                            };
                            this.printPDF(PintPDF);
                        }
                    }
                }
            ]
            // Doe : PDF 3/3 จบ
        };
    },
    watch: {
        showOrganize(val) {
            if (val == true) {
                if (this.organize_table.length > 0) {
                    this.parentmessage_organize = this.organize_table;
                } else {
                    this.parentmessage_organize = [];
                }
            }
        },
        deviceTypeOptions(val) {
            if (val != null) {
                this.deviceTypeSelected = val;
            }
        },

        vehicleOptions(val) {
            if (val != null) {
                this.vehicleSelected = val;
            }
        },

        deviceTypeSelected(val) {
            if (val != null) {
                this.error_device = false;
                if (val.length == 0) {
                    this.deviceTypeSelected = null;
                }
            }
        },

        vehicleSelected(val) {
            if (val != null) {
                this.error_vehicle = false;
                if (val.length == 0) {
                    this.vehicleSelected = null;
                }
            }
        },

        table(val) {
            if (val.length > 0) {
                this.loading = false;
                // this.loading = true;
            }
        },
        // Doe PDF เลือกได้
        columnsSelector(val) {
            if (val.length == 0) {
                this.table = [];
            } else {
                this.table = this.cloneTable;
            }
        }
    },
    async created() {
        // Doe PDF เลือกได้  4/5
        this.columnsSelector = this.columns;
        this.PDF_BodySizeSelect = this.PDF_BodySize;
        this.PDF_BodySizeHorSelect = this.PDF_BodySizeHor;

        // Doe PDF เลือกได้  4/5  จบ

        await this.axios
            .post(`${this.$url_service}/initial/option`, {
                body: { group: 'dg-09' }
            })
            .then((response) => {
                this.deviceTypeOptions = response.data.data;
            });
        await this.axios
            .post(`${this.$url_service}/initial/option`, {
                body: { group: 'dg-10' }
            })
            .then((response) => {
                this.vehicleOptions = response.data.data;
            });

        this.Clone_Data_text_Footer = this.setCloneData(this.Data_text_Footer);
    },
    mounted() {},
    methods: {
        exportCSV() {
            if (this.table != '') {
                debugger;
                this.$refs.dt.exportCSV();
            }
        },
        selectedOrganize_passValue(variable) {
            this.showOrganize = false;
            if (variable != null) {
                this.organize_table = [];
                for (let i = 0; i < variable.length; i++) {
                    this.organize_table.push({
                        organize_id: variable[i].organize_id,
                        organize_name: variable[i].organize_name
                    });
                }
            }
        },

        // Doe ค้นหา  3/6
        // async searchTable() {
        //     // console.log("this.table",this.table)
        //     // console.log("this.t",this.t)
        //     if (this.filter !== '') {
        //         this.table = this.cloneTable.filter((item) => {
        //             if (item.ev_standard_name == null || item.ev_standard_name == 'null') {
        //                 item.ev_standard_name = '-';
        //             }
        //             if (item.ev_license_plate == null || item.ev_license_plate == 'null') {
        //                 item.ev_license_plate = '-';
        //             }
        //             if (item.ev_sidecar_number == null || item.ev_sidecar_number == 'null') {
        //                 item.ev_sidecar_number = '-';
        //             }
        //             if (item.ev_car_brand == null || item.ev_car_brand == 'null') {
        //                 item.ev_car_brand = '-';
        //             }

        //             return (
        //                 (this.columns_ev_name ? item.ev_name.includes(this.filter) : '') ||
        //                 (this.columns_ev_standard_name ? item.ev_standard_name.includes(this.filter) : '') ||
        //                 (this.columns_group ? item.group.includes(this.filter) : '') ||
        //                 (this.columns_system_name ? item.system_name.includes(this.filter) : '') ||
        //                 (this.columns_ev_number ? item.ev_number.includes(this.filter) : '') ||
        //                 (this.columns_ev_license_plate ? item.ev_license_plate.includes(this.filter) : '') ||
        //                 (this.columns_ev_sidecar_number ? item.ev_sidecar_number.includes(this.filter) : '') ||
        //                 (this.columns_organize_name ? item.organize_name.includes(this.filter) : '') ||
        //                 (this.columns_status ? item.status.includes(this.filter) : '') ||
        //                 (this.columns_ev_amount ? item.ev_amount.includes(this.filter) : '') ||
        //                 //  (this.columns_ev_response_phone ? item.ev_response_phone.includes(this.filter) : "") ||
        //                 (this.columns_ev_response_phone ? item.text_tel_detail.includes(this.filter) : '') ||
        //                 (this.columns_ev_date ? item.ev_date.includes(this.filter) : '') ||
        //                 (this.columns_user_fullname ? item.user_fullname.includes(this.filter) : '') ||
        //                 (this.columns_ev_response_name ? item.ev_response_name.includes(this.filter) : '') ||
        //                 (this.ev_car_brand ? item.ev_car_brand.includes(this.filter) : '')
        //             );
        //         });
        //         // Doe : เพิ่ม ลำดับ 3/4
        //         for (let i = 0; i < this.table.length; i++) {
        //             this.table[i]['index'] = i + 1;
        //         }
        //         // Doe : เพิ่ม ลำดับ 3/4 จบ
        //         // console.log('this.table =',this.table);
        //         return this.table;
        //     } else {
        //         this.table = this.cloneTable;
        //         for (let i = 0; i < this.table.length; i++) {
        //             this.table[i]['index'] = i + 1;
        //         }
        //     }
        //     this.table = this.cloneTable;
        // },

        async searchTable() {
    if (this.filter.trim() !== '') {
        const filterText = this.filter.trim().toLowerCase();
        this.table = this.cloneTable.filter((item) => {
            // Normalize null or empty fields
            item.ev_standard_name =
                item.ev_standard_name == null || item.ev_standard_name === 'null' || item.ev_standard_name === ''
                    ? '-'
                    : item.ev_standard_name;
            item.ev_license_plate =
                item.ev_license_plate == null || item.ev_license_plate === 'null' || item.ev_license_plate === ''
                    ? '-'
                    : item.ev_license_plate;
            item.ev_sidecar_number =
                item.ev_sidecar_number == null || item.ev_sidecar_number === 'null' || item.ev_sidecar_number === ''
                    ? '-'
                    : item.ev_sidecar_number;
            item.ev_car_brand =
                item.ev_car_brand == null || item.ev_car_brand === 'null' || item.ev_car_brand === ''
                    ? '-'
                    : item.ev_car_brand;

            return (
                (this.columns_ev_name && item.ev_name && item.ev_name.toLowerCase().includes(filterText)) ||
                (this.columns_ev_standard_name &&
                    item.ev_standard_name &&
                    item.ev_standard_name.toLowerCase().includes(filterText)) ||
                (this.columns_group && item.group && item.group.toLowerCase().includes(filterText)) ||
                (this.columns_system_name &&
                    item.system_name &&
                    item.system_name.toLowerCase().includes(filterText)) ||
                (this.columns_ev_number && item.ev_number && item.ev_number.toLowerCase().includes(filterText)) ||
                (this.columns_ev_license_plate &&
                    item.ev_license_plate &&
                    item.ev_license_plate.toLowerCase().includes(filterText)) ||
                (this.columns_ev_sidecar_number &&
                    item.ev_sidecar_number &&
                    item.ev_sidecar_number.toLowerCase().includes(filterText)) ||
                (this.columns_organize_name &&
                    item.organize_name &&
                    item.organize_name.toLowerCase().includes(filterText)) ||
                (this.columns_status && item.status && item.status.toLowerCase().includes(filterText)) ||
                (this.columns_ev_amount &&
                    item.ev_amount !== undefined &&
                    String(item.ev_amount).toLowerCase().includes(filterText)) ||
                (this.columns_ev_response_phone &&
                    item.text_tel_detail &&
                    item.text_tel_detail.toLowerCase().includes(filterText)) ||
                (this.columns_ev_date && item.ev_date && item.ev_date.toLowerCase().includes(filterText)) ||
                (this.columns_user_fullname &&
                    item.user_fullname &&
                    item.user_fullname.toLowerCase().includes(filterText)) ||
                (this.columns_ev_response_name &&
                    item.ev_response_name &&
                    item.ev_response_name.toLowerCase().includes(filterText)) ||
                (this.columns_ev_car_brand && item.ev_car_brand && item.ev_car_brand.toLowerCase().includes(filterText))
            );
        });
        // Update index values
        this.table.forEach((item, i) => {
            item.index = i + 1;
        });
        return this.table;
    } else {
        // If filter is empty, reset table and update index values.
        this.table = this.cloneTable.map((item, i) => {
            item.index = i + 1;
            return item;
        });
    }
        },

        // Doe ค้นหา  3/6 จบ

        async search() {
            this.filter = '';
            this.cloneTable = [];
            var userVehicleSelected = this.vehicleSelected;
            var userDeviceTypeSelected = this.deviceTypeSelected;
            if (this.vehicleSelected == null) {
                // ถ้าประเภทยานพาหะนะไม่มีค่า ให้ '' เป็นค่าเริ่มต้น
                // console.log('this.vehicleSelected =',this.vehicleSelected)
                userVehicleSelected = '';
                // console.log('userVehicleSelected =',userVehicleSelected)
            }
            if (this.deviceTypeSelected == null) {
                // ถ้าประเภทยานพาหะนะไม่มีค่า ให้ '' เป็นค่าเริ่มต้น
                // console.log('this.deviceTypeSelected =',this.deviceTypeSelected)
                userDeviceTypeSelected = '';
                // console.log('userDeviceTypeSelected =',userDeviceTypeSelected)
            }
            // if((this.deviceTypeSelected != null)&&(this.vehicleSelected != null)){
            if (this.deviceTypeSelected != null) {
                this.loading = true;
                await this.axios
                    .post(`${this.$url_service}/get/report`, {
                        body: {
                            topic: 'get-report-equipment',
                            subtopic: 'get-report-equipment-detail',
                            organize: this.organize_table,
                            device: userDeviceTypeSelected,
                            vehicle: userVehicleSelected
                        }
                    })
                    .then((response) => {
                        this.table = response.data.data;
                        // Doe ค้นหา  4/6
                        this.cloneTable = response.data.data;
                        // Doe ค้นหา  4/6

                        // Doe : เพิ่ม ลำดับ 3/4
                        for (let i = 0; i < this.table.length; i++) {
                            this.table[i]['index'] = i + 1;
                        }
                        // Doe : เพิ่ม ลำดับ 3/4 จบ
                        //เพิ่ม จำนวน
                        // for (let i = 0; i < this.table.length; i++) {
                        //   const item = 1
                        //   this.table[i]["item"] =item;
                        // }
                        //เพิ่ม จำนวน จบ
                        // Doe : แก้ไข เวลา
                        for (let index = 0; index < this.table.length; index++) {
                            const element = this.table[index].ev_date.split('/');

                            let dateNew = new Date(`${element[1]}/${element[0]}/${element[2]}`);

                            this.table[index].ev_date = moment(dateNew).locale('th').add(543, 'year').format('LL');
                        }
                        // Doe : แก้ไข เวลา

                        // Doe ช่องว่างใส่ ขีด
                        for (let index = 0; index < this.table.length; index++) {
                            if (
                                this.table[index].ev_standard_name == null ||
                                this.table[index].ev_standard_name == 'null' ||
                                this.table[index].ev_standard_name == ''
                            ) {
                                this.table[index].ev_standard_name = '-';
                            }
                            if (this.table[index].ev_number == null || this.table[index].ev_number == 'null' || this.table[index].ev_number == '') {
                                this.table[index].ev_number = '-';
                            }
                            if (
                                this.table[index].ev_license_plate == null ||
                                this.table[index].ev_license_plate == 'null' ||
                                this.table[index].ev_license_plate == ''
                            ) {
                                this.table[index].ev_license_plate = '-';
                            }
                            if (
                                this.table[index].ev_sidecar_number == null ||
                                this.table[index].ev_sidecar_number == 'null' ||
                                this.table[index].ev_sidecar_number == ''
                            ) {
                                this.table[index].ev_sidecar_number = '-';
                            }
                            if (
                                this.table[index].ev_response_name == null ||
                                this.table[index].ev_response_name == 'null' ||
                                this.table[index].ev_response_name == ''
                            ) {
                                this.table[index].ev_response_name = '-';
                            }
                            if (
                                this.table[index].ev_response_phone == null ||
                                this.table[index].ev_response_phone == 'null' ||
                                this.table[index].ev_response_phone == ''
                            ) {
                                this.table[index].ev_response_phone = '-';
                            }
                            if (
                                this.table[index].text_tel_detail == null ||
                                this.table[index].text_tel_detail == 'null' ||
                                this.table[index].text_tel_detail == ''
                            ) {
                                this.table[index].text_tel_detail = '-';
                            }
                            if (this.table[index].ev_detail == null || this.table[index].ev_detail == 'null' || this.table[index].ev_detail == '') {
                                this.table[index].ev_detail = '-';
                            }
                        }
                        // Doe ช่องว่างใส่ ขีด

                        this.setSearchText_Footer();
                    });
                // !
                // console.log('this.table =',this.table);

                if (this.columns_disabled == true) {
                    this.table = this.cloneTable;
                } else {
                    this.table = [];
                }

                this.loading = false;
            } else {
                this.table = [];
                if (this.deviceTypeSelected == null) {
                    this.error_device = true;
                }
                if (this.vehicleSelected == null) {
                    this.error_vehicle = true;
                }
            }
        },
        setSearchText_Footer() {
            this.text_Footer = false;
            this.Data_text_Footer = this.setCloneData(this.Clone_Data_text_Footer);
            if (
                this.organize_table.length !== 0 ||
                this.deviceTypeSelected.length !== 0 ||
                this.vehicleSelected !== null ||
                this.vehicleSelected.length !== 0
            ) {
                for (let index = 0; index < this.Data_text_Footer.length; index++) {
                    const element = this.Data_text_Footer[index];
                    if (element.DataName === 'หน่วยงานรับผิดชอบ' && this.organize_table.length !== 0) {
                        element.textShow = this.setArray_to_Text(this.organize_table, 'organize_name');
                    }
                    if (element.DataName === 'ประเภทเครื่องมือ/อุปกรณ์' && this.deviceTypeSelected.length !== 0) {
                        element.textShow = this.setArray_to_Text(this.deviceTypeSelected, 'system_name');
                    }
                    if (element.DataName === 'ประเภทยานพาหนะ' && this.vehicleSelected !== null && this.vehicleSelected.length !== 0) {
                        element.textShow = this.setArray_to_Text(this.vehicleSelected, 'system_name');
                    }

                    this.text_Footer = true;
                }
            }
        },
        setArray_to_Text(data, name) {
            let text = [];
            for (let index = 0; index < data.length; index++) {
                const element = data[index];
                if (name !== null) {
                    if (element[name] !== undefined) {
                        text += element[name] + ',';
                    }
                } else {
                    text += element[name] + ',';
                }
            }
            return text.slice(0, -1);
        },

        confirmDelete() {
            this.displayConfirmation = false;
            this.organize_table = this.organize_table.filter((val) => val !== this.organizeDelete);
        },

        clearSearchField() {
            this.organize_table = [];
            this.deviceTypeSelected = null;
            this.vehicleSelected = null;
            this.error_device = false;
            this.error_vehicle = false;
            this.multiSelectClearFilerValue += 1;
            this.Data_text_Footer = this.setCloneData(this.Clone_Data_text_Footer);
            this.text_Footer = false;
            // Doe ค้นหา
            this.filter = '';
            this.table = [];
            this.cloneTable = [];
        },
        alertDisplay(temp) {
            this.$fire({
                title: 'ยืนยันการลบข้อมูล',
                text: 'คุณต้องการลบข้อมูลนี้ใช่หรือไม่ ?',

                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'ตกลง',
                cancelButtonText: 'ยกเลิก'
            }).then((result) => {
                // console.log(temp)
                if (result.value) {
                    // console.log("temp",temp)
                    this.confirmDelete(temp);
                }
            });
        },

        // Doe PDF เลือกได้  5/5
        EditPDF() {
            this.displayEditPDF = true;
            this.columnsSelectorDialog = this.columnsSelector;
        },
        SaveEditPDF() {
            //   if(this.columnsSelectorDialog.length <= 4){
            //   this.PDF_minCellWidthVer = 120
            //   this.PDF_FontHeaderVer = 13
            //   this.PDF_FontBodyVer = 10

            //   this.PDF_BodySizeSelect = {}

            //   this.PDF_minCellWidthHor = 130
            //   this.PDF_FontHeaderHor = 15
            //   this.PDF_FontBodyHor = 12

            //   this.PDF_BodySizeHorSelect = {}
            // }else if(this.columnsSelectorDialog.length <= 6){

            //   this.PDF_minCellWidthVer = 70
            //   this.PDF_FontHeaderVer = 13
            //   this.PDF_FontBodyVer = 10
            //   this.PDF_BodySizeSelect = {
            //     ev_standard_name:{cellWidth:75},
            //     system_name:{cellWidth:75},
            //     ev_date:{cellWidth:60},
            //   }

            //   this.PDF_minCellWidthHor = 90
            //   this.PDF_FontHeaderHor = 15
            //   this.PDF_FontBodyHor = 12

            //   this.PDF_BodySizeHorSelect = {
            //     ev_standard_name:{cellWidth:85},
            //   }
            // }else if(this.columnsSelectorDialog.length <= 9){
            //   this.PDF_minCellWidthVer = 60
            //   this.PDF_FontHeaderVer = 10
            //   this.PDF_FontBodyVer = 7
            //   this.PDF_BodySizeSelect = {
            //     ev_standard_name:{cellWidth:72},

            //     organize_name:{cellWidth:58},
            //     ev_date:{cellWidth:45}
            //   }

            //   this.PDF_minCellWidthHor = 70
            //   this.PDF_FontHeaderHor = 12
            //   this.PDF_FontBodyHor = 10

            //   this.PDF_BodySizeHorSelect = {
            //     ev_standard_name:{cellWidth:70},

            //     ev_date:{cellWidth:55}
            //   }
            // }else if(this.columnsSelectorDialog.length <= 13){
            //   this.PDF_minCellWidthVer = 50
            //   this.PDF_FontHeaderVer = 7.5
            //   this.PDF_FontBodyVer = 5.5
            //   this.PDF_BodySizeSelect = {
            //     index: {cellWidth: 22},
            //     ev_name:{cellWidth:38},
            //     ev_standard_name:{cellWidth:45,fontSize: 5},
            //     group:{cellWidth:42,fontSize: 5.5},
            //     system_name:{cellWidth:40,fontSize: 5.5},
            //     organize_name:{cellWidth:45},
            //     ev_date:{cellWidth:38},

            //     status:{cellWidth:27},
            //     ev_amount:{cellWidth:25},
            //   }

            //   this.PDF_minCellWidthHor = 73
            //   this.PDF_FontHeaderHor = 12
            //   this.PDF_FontBodyHor = 10

            //   this.PDF_BodySizeHorSelect = {
            //     index: {cellWidth: 30},
            //     ev_name:{cellWidth:55},
            //     ev_standard_name:{cellWidth:70},
            //     group:{cellWidth:45,fontSize: 10},
            //     system_name:{cellWidth:60,fontSize: 10},
            //     organize_name:{cellWidth:70},
            //     ev_date:{cellWidth:55,fontSize: 10},

            //     status:{cellWidth:40},
            //     ev_amount:{cellWidth:35},
            //   }
            // }else if(this.columnsSelectorDialog.length <= 14){
            //   this.PDF_minCellWidthVer = 50
            //   this.PDF_FontHeaderVer = 7.5
            //   this.PDF_FontBodyVer = 5.5
            //   this.PDF_BodySizeSelect = {
            //     index: {cellWidth: 22},
            //     ev_name:{cellWidth:38},
            //     ev_standard_name:{cellWidth:45,fontSize: 5},
            //     group:{cellWidth:42,fontSize: 5.5},
            //     system_name:{cellWidth:40,fontSize: 5.5},
            //     ev_number:{cellWidth:35},
            //     ev_license_plate:{cellWidth:35},
            //     ev_sidecar_number:{cellWidth:38},
            //     organize_name:{cellWidth:45},
            //     // ev_response_phone:{cellWidth:28},
            //     text_tel_detail:{cellWidth:28},
            //     // ev_response_name:{cellWidth:42},

            //     status:{cellWidth:27},
            //     ev_amount:{cellWidth:25},
            //                     // user_fullname:{cellWidth:48.5},
            //     ev_date:{cellWidth:38},
            //   }

            //   this.PDF_minCellWidthHor = 73
            //   this.PDF_FontHeaderHor = 12
            //   this.PDF_FontBodyHor = 10

            //   this.PDF_BodySizeHorSelect = {
            //     index: {cellWidth: 30},
            //     ev_name:{cellWidth:55},
            //     ev_standard_name:{cellWidth:70},
            //     group:{cellWidth:45,fontSize: 10},
            //     system_name:{cellWidth:60,fontSize: 10},
            //     ev_number:{cellWidth:50},
            //     ev_license_plate:{cellWidth:50},
            //     ev_sidecar_number:{cellWidth:55},
            //     organize_name:{cellWidth:70},
            //     // ev_response_phone:{cellWidth:50},
            //     text_tel_detail:{cellWidth:50},

            //     // ev_response_name:{cellWidth:50},

            //     status:{cellWidth:40},
            //     ev_amount:{cellWidth:35},
            //     ev_date:{cellWidth:55,fontSize: 10},
            //   }
            // }else{
            //   this.PDF_minCellWidthVer = 50
            //   this.PDF_FontHeaderVer = 7.5
            //   this.PDF_FontBodyVer = 5.5
            //   this.PDF_BodySizeSelect = this.PDF_BodySize

            //   this.PDF_minCellWidthHor = 73
            //   this.PDF_FontHeaderHor = 12
            //   this.PDF_FontBodyHor = 10

            //   this.PDF_BodySizeHorSelect = this.PDF_BodySizeHor
            // }

            if (this.columnsSelectorDialog.length <= 4) {
                this.PDF_minCellWidthVer = 120;
                this.PDF_FontHeaderVer = 13;
                this.PDF_FontBodyVer = 11;

                this.PDF_BodySizeSelect = {
                    index: { cellWidth: 35 }
                };
                if (this.columnsSelectorDialog.length == 4) {
                    this.PDF_BodySizeSelect = {
                        index: { cellWidth: 35 },

                        status: { cellWidth: 45 },
                        ev_amount: { cellWidth: 45 }
                    };
                }

                this.PDF_minCellWidthHor = 130;
                this.PDF_FontHeaderHor = 15;
                this.PDF_FontBodyHor = 13;

                this.PDF_BodySizeHorSelect = {
                    index: { cellWidth: 35 }
                };
            } else if (this.columnsSelectorDialog.length <= 6) {
                this.PDF_minCellWidthVer = 90;
                this.PDF_FontHeaderVer = 13;
                this.PDF_FontBodyVer = 11;

                this.PDF_BodySizeSelect = {
                    index: { cellWidth: 35 },
                    ev_standard_name: { cellWidth: 120 },
                    status: { cellWidth: 45 },
                    ev_amount: { cellWidth: 45 }
                };
                if (this.columnsSelectorDialog.length == 6) {
                    this.PDF_BodySizeSelect = {
                        index: { cellWidth: 35 },

                        ev_standard_name: { cellWidth: 115 },

                        ev_sidecar_number: { cellWidth: 60 },

                        status: { cellWidth: 45 },
                        ev_amount: { cellWidth: 45 }
                    };
                }

                this.PDF_minCellWidthHor = 130;
                this.PDF_FontHeaderHor = 15;
                this.PDF_FontBodyHor = 13;

                this.PDF_BodySizeHorSelect = {
                    index: { cellWidth: 35 }
                };
            } else if (this.columnsSelectorDialog.length <= 10) {
                this.PDF_minCellWidthVer = 50;
                this.PDF_FontHeaderVer = 9;
                this.PDF_FontBodyVer = 7;
                this.PDF_BodySizeSelect = {
                    index: { cellWidth: 30 },
                    ev_standard_name: { cellWidth: 85 },
                    system_name: { cellWidth: 60 },
                    ev_response_name: { cellWidth: 70 },
                    organize_name: { cellWidth: 55 },
                    // ev_number:{cellWidth:40},
                    ev_amount: { cellWidth: 40 }
                    // ev_detail:{cellWidth:48},
                };
                if (this.columnsSelectorDialog.length == 10) {
                    this.PDF_BodySizeSelect = {
                        index: { cellWidth: 30 },
                        ev_standard_name: { cellWidth: 85 },
                        system_name: { cellWidth: 60 },

                        ev_response_name: { cellWidth: 65 },
                        organize_name: { cellWidth: 55 },
                        ev_sidecar_number: { cellWidth: 55 },
                        ev_number: { cellWidth: 40 },
                        ev_detail: { cellWidth: 48 },

                        ev_amount: { cellWidth: 35 }
                    };
                }

                this.PDF_minCellWidthHor = 80;
                this.PDF_FontHeaderHor = 13;
                this.PDF_FontBodyHor = 11;

                this.PDF_BodySizeHorSelect = {
                    index: { cellWidth: 35 },
                    ev_standard_name: { cellWidth: 90 },
                    organize_name: { cellWidth: 75 }
                };
            } else if (this.columnsSelectorDialog.length <= 13) {
                this.PDF_minCellWidthVer = 40;
                this.PDF_FontHeaderVer = 7.5;
                this.PDF_FontBodyVer = 5.5;
                this.PDF_BodySizeSelect = {
                    ev_name: { cellWidth: 38 },
                    ev_standard_name: { cellWidth: 57 },
                    group: { cellWidth: 40 },
                    system_name: { cellWidth: 38, fontSize: 6 },
                    ev_license_plate: { cellWidth: 35 },
                    ev_sidecar_number: { cellWidth: 37 },
                    text_tel_detail: { cellWidth: 28 },
                    // ev_response_phone:{cellWidth:28},
                    status: { cellWidth: 27 },
                    ev_detail: { cellWidth: 33 },
                    organize_name: { cellWidth: 45 },
                    ev_amount: { cellWidth: 25 },

                    ev_date: { cellWidth: 37 }
                };

                this.PDF_minCellWidthHor = 50;
                this.PDF_FontHeaderHor = 12;
                this.PDF_FontBodyHor = 10;

                this.PDF_BodySizeHorSelect = {
                    ev_standard_name: { cellWidth: 70 },
                    organize_name: { cellWidth: 70 },
                    group: { cellWidth: 60, fontSize: 10 },
                    system_name: { cellWidth: 60, fontSize: 10 },
                    ev_number: { cellWidth: 50 },
                    ev_detail: { cellWidth: 48 },
                    ev_sidecar_number: { cellWidth: 45 },
                    ev_date: { cellWidth: 55, fontSize: 10 }
                };
            } else if (this.columnsSelectorDialog.length <= 14) {
                this.PDF_minCellWidthVer = 40;
                this.PDF_FontHeaderVer = 7.5;
                this.PDF_FontBodyVer = 5.5;
                this.PDF_BodySizeSelect = {
                    ev_name: { cellWidth: 38 },
                    ev_standard_name: { cellWidth: 57 },
                    group: { cellWidth: 40 },
                    system_name: { cellWidth: 40 },
                    ev_response_name: { cellWidth: 42 },
                    organize_name: { cellWidth: 45 },
                    ev_license_plate: { cellWidth: 35 },
                    ev_sidecar_number: { cellWidth: 37 },
                    text_tel_detail: { cellWidth: 28 },
                    // ev_response_phone:{cellWidth:28},
                    ev_detail: { cellWidth: 33 },
                    status: { cellWidth: 27 },
                    ev_amount: { cellWidth: 25 },

                    ev_date: { cellWidth: 37 }
                };

                this.PDF_minCellWidthHor = 50;
                this.PDF_FontHeaderHor = 12;
                this.PDF_FontBodyHor = 10;

                this.PDF_BodySizeHorSelect = {
                    ev_name: { cellWidth: 60 },
                    ev_standard_name: { cellWidth: 85 },
                    group: { cellWidth: 60 },
                    system_name: { cellWidth: 60 },
                    organize_name: { cellWidth: 70 },
                    ev_number: { cellWidth: 52 },
                    ev_sidecar_number: { cellWidth: 55 },
                    ev_date: { cellWidth: 55 },
                    status: { cellWidth: 40 },
                    text_tel_detail: { cellWidth: 40 },
                    // ev_response_phone:{cellWidth:40},
                    ev_detail: { cellWidth: 49 },

                    ev_amount: { cellWidth: 35 }
                };
            } else if (this.columnsSelectorDialog.length <= 15) {
                this.PDF_minCellWidthVer = 50;
                this.PDF_FontHeaderVer = 7.5;
                this.PDF_FontBodyVer = 5.5;
                this.PDF_BodySizeSelect = {
                    index: { cellWidth: 21.5 },
                    ev_name: { cellWidth: 28 },
                    ev_standard_name: { cellWidth: 40 },
                    group: { cellWidth: 42, fontSize: 6 },
                    system_name: { cellWidth: 38, fontSize: 6 },
                    ev_number: { cellWidth: 35 },
                    ev_license_plate: { cellWidth: 35 },
                    ev_sidecar_number: { cellWidth: 38 },
                    organize_name: { cellWidth: 45 },
                    text_tel_detail: { cellWidth: 28 },
                    // ev_response_phone:{cellWidth:28},
                    ev_detail: { cellWidth: 33 },
                    ev_response_name: { cellWidth: 42 },

                    // status:{cellWidth:27},
                    ev_amount: { cellWidth: 24.5 },
                    // user_fullname:{cellWidth:48.5},
                    ev_date: { cellWidth: 37 }
                };

                this.PDF_minCellWidthHor = 50;
                this.PDF_FontHeaderHor = 12;
                this.PDF_FontBodyHor = 10;

                this.PDF_BodySizeHorSelect = {
                    index: { cellWidth: 30 },
                    ev_name: { cellWidth: 55 },
                    ev_standard_name: { cellWidth: 70 },
                    group: { cellWidth: 60, fontSize: 10 },
                    system_name: { cellWidth: 60, fontSize: 10 },
                    ev_number: { cellWidth: 50 },
                    ev_license_plate: { cellWidth: 50 },
                    ev_sidecar_number: { cellWidth: 45 },
                    organize_name: { cellWidth: 70 },
                    text_tel_detail: { cellWidth: 40 },
                    // ev_response_phone:{cellWidth:40},
                    ev_detail: { cellWidth: 48 },
                    ev_response_name: { cellWidth: 50 },

                    // status:{cellWidth:40},
                    ev_amount: { cellWidth: 35 },
                    ev_date: { cellWidth: 55, fontSize: 10 }
                };
            } else {
                this.PDF_minCellWidthVer = 50;
                this.PDF_FontHeaderVer = 7.5;
                this.PDF_FontBodyVer = 5.5;
                this.PDF_BodySizeSelect = this.PDF_BodySize;

                this.PDF_minCellWidthHor = 50;
                this.PDF_FontHeaderHor = 12;
                this.PDF_FontBodyHor = 10;

                this.PDF_BodySizeHorSelect = this.PDF_BodySizeHor;
            }

            this.columnsSelector = this.columnsSelectorDialog;

            if (this.columnsSelectorDialog.length == 0) {
                this.columns_index = false;
                this.columns_ev_name = false;
                this.columns_ev_standard_name = false;
                this.columns_group = false;
                this.columns_system_name = false;
                this.columns_ev_number = false;
                this.columns_ev_license_plate = false;
                this.columns_ev_sidecar_number = false;

                this.columns_organize_name = false;
                this.columns_status = false;
                this.columns_ev_detail = false;
                this.columns_ev_amount = false;
                this.columns_ev_response_name = false;
                this.columns_ev_response_phone = false;
                this.columns_ev_date = false;
                this.columns_user_fullname = false;

                this.columns_disabled = false;
            } else if (this.columnsSelectorDialog.length == 16) {
                this.columns_index = true;
                this.columns_ev_name = true;
                this.columns_ev_standard_name = true;
                this.columns_group = true;
                this.columns_system_name = true;
                this.columns_ev_number = true;
                this.columns_ev_license_plate = true;
                this.columns_ev_sidecar_number = true;

                this.columns_organize_name = true;
                this.columns_status = true;
                this.columns_ev_detail = true;
                this.columns_ev_amount = true;
                this.columns_ev_response_name = true;
                this.columns_ev_response_phone = true;
                this.columns_ev_date = true;
                this.columns_user_fullname = true;

                this.columns_disabled = true;
            } else {
                this.columns_disabled = true;
                // console.log('this.columnsSelectorDialog =', this.columnsSelectorDialog);

                let getData = [];
                // ! จัดข้อมูล
                for (let index = 0; index < this.columnsSelector.length; index++) {
                    getData.push(this.columnsSelector[index].dataKey);
                }

                // console.log("getData",getData);

                // ! เช็คข้อมูล

                for (let index = 0; index < this.columnsSelector.length; index++) {
                    const element = this.columnsSelector[index].dataKey;

                    if (element == 'index') {
                        this.columns_index = true;
                    } else if (!getData.includes('index')) {
                        // console.log("getData.includes(index)",getData.includes("index"))
                        this.columns_index = false;
                    }

                    if (element == 'ev_name') {
                        this.columns_ev_name = true;
                    } else if (!getData.includes('ev_name')) {
                        this.columns_ev_name = false;
                    }

                    if (element == 'ev_standard_name') {
                        this.columns_ev_standard_name = true;
                    } else if (!getData.includes('ev_standard_name')) {
                        this.columns_ev_standard_name = false;
                    }

                    if (element == 'group') {
                        this.columns_group = true;
                    } else if (!getData.includes('group')) {
                        this.columns_group = false;
                    }

                    if (element == 'system_name') {
                        this.columns_system_name = true;
                    } else if (!getData.includes('system_name')) {
                        this.columns_system_name = false;
                    }

                    if (element == 'ev_number') {
                        this.columns_ev_number = true;
                    } else if (!getData.includes('ev_number')) {
                        this.columns_ev_number = false;
                    }

                    if (element == 'ev_license_plate') {
                        this.columns_ev_license_plate = true;
                    } else if (!getData.includes('ev_license_plate')) {
                        this.columns_ev_license_plate = false;
                    }

                    if (element == 'ev_sidecar_number') {
                        this.columns_ev_sidecar_number = true;
                    } else if (!getData.includes('ev_sidecar_number')) {
                        this.columns_ev_sidecar_number = false;
                    }

                    if (element == 'organize_name') {
                        this.columns_organize_name = true;
                    } else if (!getData.includes('organize_name')) {
                        this.columns_organize_name = false;
                    }

                    if (element == 'status') {
                        this.columns_status = true;
                    } else if (!getData.includes('status')) {
                        this.columns_status = false;
                    }

                    if (element == 'ev_detail') {
                        this.columns_ev_detail = true;
                    } else if (!getData.includes('ev_detail')) {
                        this.columns_ev_detail = false;
                    }

                    if (element == 'ev_amount') {
                        this.columns_ev_amount = true;
                    } else if (!getData.includes('ev_amount')) {
                        this.columns_ev_amount = false;
                    }

                    if (element == 'ev_response_name') {
                        this.columns_ev_response_name = true;
                    } else if (!getData.includes('ev_response_name')) {
                        this.columns_ev_response_name = false;
                    }

                    // if (element == "ev_response_phone") {
                    //   this.columns_ev_response_phone = true
                    // } else if(!getData.includes("ev_response_phone")){
                    //   this.columns_ev_response_phone = false
                    // }

                    if (element == 'text_tel_detail') {
                        this.columns_ev_response_phone = true;
                    } else if (!getData.includes('text_tel_detail')) {
                        this.columns_ev_response_phone = false;
                    }

                    if (element == 'ev_date') {
                        this.columns_ev_date = true;
                    } else if (!getData.includes('ev_date')) {
                        this.columns_ev_date = false;
                    }

                    if (element == 'user_fullname') {
                        this.columns_user_fullname = true;
                    } else if (!getData.includes('user_fullname')) {
                        this.columns_user_fullname = false;
                    }
                }
            }

            this.displayEditPDF = false;
            this.filter = '';
        },
        CloseEditPDF() {
            this.displayEditPDF = false;
        },
        ClearEditPDF() {
            this.columnsSelectorDialog = [];
        },
        SelectAllEditPDF() {
            this.columnsSelectorDialog = this.columns;
        }
        // Doe PDF เลือกได้  5/5 จบ
    }
};
</script>

<style scoped>
.table_statusColor {
    color: #090073;
    display: inline-flex;
    padding: 5px 15px 5px 15px;
    font-weight: bolder;
    border-radius: 10px;
}
.table_row {
    text-align: center;
}

@media screen and (min-width: 819px) and (max-width: 1200px) {
    #Search {
        width: 20rem;
    }
}
/* // Doe PDF เลือกได้ */
#TABLE_EDIT {
    width: 149px;
}
@media screen and (max-width: 818px) {
    #Search {
        width: 100%;
    }
}
.p-field {
    margin-bottom: 0rem;
}
</style>

<style>
.p-datatable-thead {
    border: 2px solid #d6d6d6;
}

.p-datatable-tbody {
    border: 2px solid #d6d6d6;
}
</style>

<style scoped lang="scss">
:deep(.p-dialog) {
    @media screen and (max-width: 991px) {
        .p-dialog-content {
            overflow-y: auto;
        }
    }
}
.p-multiselect {
    min-width: 15rem;
}

.multiselect-custom {
    // Doe PDF เลือกได้
    width: 100%;
    .p-multiselect-label:not(.p-placeholder) {
        padding-top: 0.25rem;
        padding-bottom: 0.25rem;
    }

    .item {
        display: flex;
        align-items: center;
    }

    .item-value {
        padding-left: 10px;
        padding-right: 10px;
        border-radius: 3px;
        display: inline-flex;
        margin-right: 0.5rem;
        background-color: var(--primary-color);
        color: var(--primary-color-text);
    }
}
</style>
